let apiServer = "";
let isWxEnv = true;
let isWxAppEnv = false;
let isTestEnv = false;
let isAliPayEnv = false;
if (process.env.NODE_ENV == "production") {
  apiServer = "https://bowlingapi.cloudysea.com";
  //isTestEnv = true;
} else if (process.env.NODE_ENV == "development") {
  apiServer = "https://localhost:7056/";
  //apiServer = "https://bowlingapi.cloudysea.com";
  isTestEnv = true;
  //apiServer = "http://bowling.cloudysea.com";
}

if (/AlipayClient/.test(window.navigator.userAgent)) {
  isAliPayEnv = true;
}

export default {
  apiServer,
  isWxEnv,
  isWxAppEnv,
  isTestEnv,
  isAliPayEnv,
};
